import { connect } from 'react-redux';
import FeedbackScreen from './FeedbackScreen.View';
import type { OwnProps, StateProps } from './FeedbackScreen.View';
import type { RootState } from '../../store/Store';

const mapStateToProps = (state: RootState, _: OwnProps): StateProps => {
	return {
		surveyUrl: state.configuration.surveyUrl
	};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackScreen);
